import { render, staticRenderFns } from "./EditPasswordModal.vue?vue&type=template&id=5f6e47c8&"
import script from "./EditPasswordModal.vue?vue&type=script&lang=js&"
export * from "./EditPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports